import { message } from 'antd'

message.config({
    duration: 5,
})

export default message
